<template>
  <div>
    <!--头部信息-->
    <public-title>返利中心
      <span v-show="isGroup" class="text-link ml-auto" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <rebate-title/>
    <div class="bg-white pb-4">
      <div class="d-center-between pl-3 pr-3">
        <el-row class="w-100 mt-3 text-left">
          <el-col :span="6">
            <el-select class="mt-1" v-model="rebatetype" @change="rbtchange">
              <el-option label="全部" value="" />
              <el-option label="度假产品" value="7" />
              <el-option label="景区门票" value="6" />
            </el-select>
          </el-col>
          <el-col :span="18">
            <!--tab选项卡-->
            <el-menu mode="horizontal" class="w-70 inline" @select="handleSelect" :default-active="activeName">
              <el-menu-item index="all">总计返利</el-menu-item>
              <el-menu-item index="available">可提返利</el-menu-item>
              <el-menu-item index="done">已提返利</el-menu-item>
              <el-menu-item index="frozen">冻结中
                <el-tooltip class="item" effect="dark" content="平台打款处理中" placement="top-start">
                  <i class="el-icon-info h6 text-info"/>
                </el-tooltip>
              </el-menu-item>
            </el-menu>
            <div class="w-30 inline text-right">
              <el-button class="ml-4 inline" size="small" type="success" @click="applyCtrol" v-show="activeName === 'available'">申请提现</el-button>
              <!-- <el-button class="ml-4 inline" size="small" type="success" @click="applyAllCtrol" v-show="activeName === 'available'">全部提现</el-button> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <!--搜索框-->
      <div class="pl-5 pr-5 mt-2">
        <p class="text-right text-link" @click="currentPage=1;getRebateInfo()">搜索</p>
        <div class="d-center-between mt-3">
          <div class="block">
            <span class="demonstration pr-2">按时间</span>
            <el-date-picker
              size="small"
              v-model="timeStamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="d-center">
            <p class="pr-2">产品名称</p>
            <el-input v-model="searchName" placeholder="按名称搜索" style="width: 350px"></el-input>
          </div>
        </div>
      </div>
      <display-list :tab="activeName" ref="AllChecked" />
      <div class="w-100 d-center">
        <el-pagination background layout="prev, pager, next" class="mt-4" v-if="RebateInfo.count > 0 && showTenNum"
            :total="RebateInfo.count" :current-page="Number(queryCon.page)"
            @current-change="v => this.currentPage=v"/>
      </div>
    </div>
    <!--提现选择银行卡/开票选择开票信息-->
    <el-dialog :visible.sync="beginCtrol" center title="申请提现">
      <div class="d-start-center">
        <left-text leftText="请选择银行卡"/>
        <div v-if = "activeName==='available'" class="w-100">
          <div class="single-choose mb-2 w-80" v-for="item in StoreBankcardList.lists" :key="item .id"
               @click="chooseBackup = item.id" :class="{'active':chooseBackup === item.id || StoreBankcardList.lists.length == 1, 'defaultbg': item.is_default == 1 && !chooseBackup}">
            <p class="d-center-between w-100">
              <span>{{item.bank}}&nbsp;({{item.truename}})<label v-if="item.is_default == 1" class="text-muted mr-2">(默认)</label></span>
              <span>
                尾号：{{item.card.substr(item.card.length - 4)}}
              </span>
            </p>
          </div>
          <p class="single-choose w-80" @click="$router.push({name:'addBankcard',query:{store:queryCon.storeId}})">
            <span class="iconfont mr-3 icon-jia h6">去添加新项</span>
          </p>
        </div>
      </div>
      <p class="text-center mt-4" v-show="activeName==='available'">
        申请提现金额：&yen;{{totalWithdraw | formatMoney}}元
        <span class="ml-4">实际到账金额：&yen;{{totalWithdraw | formatMoney}}元</span>
      </p>
      <span slot="footer">
          <el-button @click="cancelCtrol">取 消</el-button>
          <el-button type="primary" @click="ensureCtrol">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState,mapActions,mapGetters } from 'vuex'
  import RebateTitle from './RebateTitle'
  import DisplayList from './DisplayList'

  export default {
    name: 'RebateIncome',
    components: {RebateTitle, DisplayList},
    data() {
      return {
        activeName: 'all',                                  //默认选择
        currentPage: 1,                                     //当前页码
        timeStamp: '',                                      //选中时间戳
        searchName: '',                                     //选中名字
        beginCtrol:false,                                   //是否显示控制面板
        chooseBackup:'',                                     //当前选中的银行卡
        rebatetype: '',
        showTenNum:true
      }
    },
    computed: {
      ...mapState(['RebateInfo','StoreMoneyList','StoreBankcardList', 'userLoginMessage']),
      ...mapGetters(['userInfo','storeInfo','isGroup']),
      //使用路由来记录的页数
      queryCon() { return this.$route.query },
      //申请提现总额
      totalWithdraw() {
        if (this.activeName !== 'available') return 0;
        let list = this.RebateInfo.data || [];
        let newlist = list.filter(v => v.checked);
        let total = 0;
        newlist.forEach(v => {
          total += Number(v.parent_money)
        });
        return total;
        },
    },
    created() {
      if (this.queryCon.storeId) this.activeName = this.queryCon.tab
      this.getRebateInfo();
    },
    watch: {
      currentPage(newVal) {
        let query = {...this.queryCon, page: newVal};
        this.$router.push({name: this.$route.name, query})
      },
      queryCon(newVal) {
        if (newVal.tab) {
          this.activeName = newVal.tab;
          //同时清空搜索条件
          this.timeStamp = '';
          this.searchName = '';
        }
        this.getRebateInfo();
      },
    },
    methods: {
      ...mapActions(['getRebateIncome','getStoreBankcardLists','storeWithdraw']),
      rbtchange () {
        this.currentPage = 1
        let query = {...this.queryCon, page: 1};
        this.$router.push({name: this.$route.name, query})
        this.getRebateInfo()
      },
      //切换tab
      handleSelect(key) {
        this.currentPage = 1;
        this.activeName = key;
        this.$router.push({
          name: this.$route.name,
          query: {...this.$route.query, tab: key, page: this.currentPage}
        })
      },
      getRebateInfo(nonum) {
        let start, end, withdraw,page = this.queryCon.page,productName = this.searchName;
        start = this.timeStamp ? this.timeStamp[0].getTime() / 1000 : '';
        end = this.timeStamp ?  this.timeStamp[1].getTime() / 1000 : '';
        switch (this.queryCon.tab) {
          case 'all' : withdraw = ''; break;
          case 'available' : withdraw = '0'; break;
          case 'done' : withdraw = '1'; break;
          case 'frozen' : withdraw = '2'; break;
        }
        let data = {
          start, end, withdraw, page, productName, style: this.rebatetype
        }
        if (nonum) data.num = ''
        this.getRebateIncome({data, successFun: res => {if(nonum) this.applyCtrol()}});
      },
      applyAllCtrol () {
        this.showTenNum = false
        this.getRebateInfo('nonum')
      },
      //申请提现
      applyCtrol() {
        if (!this.$GFUN.powerIsInArray([257,203,211,323,326,411,417])) { this._alert('您没有相关权限！',null,'error'); return; }
        let lists = this.RebateInfo.data.filter(v => v.checked);
        if (lists.length <= 0) { this._alert('请选择操作项',null,'error'); return }
        if (this.totalWithdraw < 10 && this.activeName === 'available') {
          this._alert('可提金额少于10元，无法发起提现',null,'error'); return
        }
        this.getStoreBankcardLists();
        this.beginCtrol = true;
      },
      cancelCtrol () {
        this.beginCtrol = false
        if (!this.showTenNum) {
          this.showTenNum = true;
          this.getRebateInfo()
        }
      },
      //提现
      async ensureCtrol() {
        if (!this.chooseBackup) {
          if (this.StoreBankcardList.lists.length == 1) this.chooseBackup = this.StoreBankcardList.lists[0].id
          else {
            let defaultarr = this.StoreBankcardList.lists.filter(v => v.is_default)
            if (defaultarr.length > 0) this.chooseBackup = defaultarr[0].id
          }
        }
        if (!this.chooseBackup) { this._alert('当前尚未选择任何银行卡',null,'error'); return }
        let data = {
            bank:this.chooseBackup,
            id: this.RebateInfo.data.map(v => { if (v.checked) return v.id }),
            order_style:7
        };
        let res = await this.$axios.post('/pc/Common/storeDrawProductRebate',{
          bank:this.chooseBackup,
          id: this.RebateInfo.data.map(v => { if (v.checked) return v.id }),
          store_id: this.isGroup ? this.queryCon.storeId :this.storeInfo.storeId
        });
        if (res.code === '00000') {
          this.beginCtrol = false;
          this._alert('提现申请成功，请等待管理员审核打款',() => { this.getRebateInfo(); })
        }

        // this.storeWithdraw({
        //   data,
        //   successFun: () => {
        //     this.beginCtrol = false;
        //     this._alert('提现申请成功，请等待管理员审核打款',() => { this.getRebateInfo(); })
        //   }
        // });
      }
    }
  }
</script>

<style lang="scss" scoped>
.defaultbg {
  border-color: #10c568;
  background: #ebfcf3
}
.inline{
  vertical-align: middle;
  .el-menu-item{
    height: 45px;
    line-height: 45px
  }
}
</style>
